export * from './vermerk-entfernt.interface';
